// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__lLMarjCq","error":"Captcha_error__Xc+jgxWW"};